import {BannerDataImage} from '@core-client/ads/banner/data/BannerDataImage';

import {BannerRenderer} from './BannerRenderer';

export class ImageBannerRenderer extends BannerRenderer {
    showBannerDiv(banner: BannerDataImage) {
        this.bannerView.showContainer();
        this.bannerView.setBannerHtml(
            this.renderHtml(banner, this.bannerView.encodeClickParam())
        );

        if (banner !== null && banner.impressionUrls !== null && banner.impressionUrls.length) {
            setTimeout(() => {
                banner.impressionUrls.forEach((impressionUrl) => {
                    const img = new Image();
                    img.src = impressionUrl;
                });
            }, 10);
        }
    }

    renderHtml(image: BannerDataImage, bannerClickParam: string): string {
        return  "<div class=\"rb_div\">" +
            "<div class=\"rb_banner\">" +
            "<a href=\"" + image.targetUrl + "\" onclick=\"rb_js_bannerClick('" + bannerClickParam + "');return false;\">" +
            "<img src=\"" + image.url + "\" width=\"" + image.width + "\" height=\"" + image.height + "\"" +
            " border=\"0\" alt=\"" + image.title + "\" title=\"" + image.title + "\"/>" +
            "</a>" +
            "</div>" +
            "</div>";
    }
}
